import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  OnInit
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { NavigationEnd, Router } from "@angular/router";
import { MainStateService } from "@core_n/common/main-state.service";
import { ObjectsMenuService } from "@core_n/menu-bars/objects-menu.service";
import { setFocus } from "../../app/common/ZIndexMngr";
import { IcmsSplitArea } from "..//icms-split/icms-split.types";
import { AppConfig } from "../app.config";
import { aspMngr } from "../asp/AspMngr";
import { getNewmiLoadingConfig, mainMapMngr, MapMngr } from "../asp/MapMngr";
import { SessionService } from "../common/session.service";
import * as settings from "../common/settings";
import { MsgMngrService } from "../msg/msg-mngr.service";
import { SecondScreenComponent } from "../second-screen/second-screen.component";
import { StatusBarService } from "../status-bar/status-bar.service";
import { SubAreaService } from "../sub-area/sub-area.service";
import { IcmsSplitPreset } from "./../icms-split/icms-split.types";

@Component({
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
})
export class MainComponent implements OnInit {
  private readonly _splitAreasHorizontal: IcmsSplitArea[] = [
    { size: 100, middleSize: 40 },
    { size: 0, middleSize: 45 },
    { size: 0, middleSize: 15 },
  ];
  private readonly _splitAreasVertical: IcmsSplitArea[] = [
    { size: 0, middleSize: 55 },
    { size: 100, middleSize: 45 },
  ];

  private readonly _splitAreasHorizontalSmall: IcmsSplitArea[] = [
    { size: 50, middleSize: 50 },
    { size: 50, middleSize: 50 },
  ];

  public icmsSplitAreasHorizontal: IcmsSplitArea[] = this._splitAreasHorizontal.filter(
    () => true
  );
  public icmsSplitAreasVertical: IcmsSplitArea[] = this._splitAreasVertical.filter(
    () => true
  );
  public icmsSplitAreasHorizontalSmall: IcmsSplitArea[] = this._splitAreasHorizontalSmall.filter(
    () => true
  );

  upperBarHeight = -46;

  private readonly OBJECTS_UPDATE_RATE: number =
    AppConfig.settings.map.refreshRate; // every xxx ms the data will be updated and redrawn

  private mainMapMngr: MapMngr;

  newmiLoadingConfig = getNewmiLoadingConfig();
  splitScreenPreset?: IcmsSplitPreset = "minSize";

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private msgMngr: MsgMngrService,
    private mainStateService: MainStateService,
    private menuService: ObjectsMenuService,
    private subAreaService: SubAreaService,
    private statusBarSrv: StatusBarService,
    protected compFactResolver: ComponentFactoryResolver,
    protected router: Router,
    protected sessionSerive: SessionService,
    protected cdr: ChangeDetectorRef,
    protected videoMngrService: VideoMsgMngrService
  ) {
    window["$scope"] = this;
    window["startTime"] = new Date().getTime();

    let svgIcons = [
      "aro",
      "bm",
      "display-filter",
      "bit",
      "settings",
      "tfp",
      "weather",
      "playback",
      "map",
      "map-3d",
      "map-sat",
      "map-outline",
      "free-drawing",
      "ruler",
      "home",
      "jump-to",
      "bulls-eye",
      "second-map",
      "maps-filter",
      "zones-filter",
      "lines-filter",
      "points-filter",
      "targets-filter",
      "tracks-filter",
      "plots-filter",
      "sensors-filter",
    ];

    for (let icon of svgIcons) {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `./assets/Images/${icon}-icon.svg`
        )
      );
    }

    // Create main map object
    this.mainMapMngr = new MapMngr(true);

    // Disable middle button handling by browser
    document.addEventListener(
      "mousedown",
      function (e) {
        if (e.button == 1) e.preventDefault();
        setFocus(false);
      },
      true
    );

    document.addEventListener(
      "mouseup",
      function (e) {
        if (e.button == 0) {
          menuService.hideAllMenus();
          settings.userSettings.menuCloser.next(true);

          // e.preventDefault();
        }
      },
      true
    );

    // Disable browser context menu
    document.addEventListener(
      "contextmenu",
      function (e) {
        e.preventDefault();
      },
      true
    );

    // Handle keyboard press
    document.addEventListener(
      "keydown",
      function (e) {
        if (
          menuService.handleKeyboardEvent(e) ||
          mainMapMngr.handleKeyboardEvent(e)
        ) {
          // mainMapMngr.handleKey(e);
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    let _this = this;
    setInterval(function () {
      _this.periodicUpdate();
    }, this.OBJECTS_UPDATE_RATE);
  }

  ngOnInit(): void {
    this.mainStateService.splitScreenToggleClick$.subscribe((showSplitScreen) => {
      this.setSplit(showSplitScreen);
    });

    let _this = this;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) _this.sessionSerive.leaveMainPage();
    });
    setTimeout(() => {
      this.videoMngrService.getSensorsList();
    }, 300)
  }

  // ngAfterViewInit() {
  //   this.upperBarHeight = settings.upperBarHeight;
  // }

  isSecondScreenShown() {
    return SecondScreenComponent.isShown();
  }

  onMapLoaded(map) {
    mainMapMngr.initMap(map.map);

    // // @ts-ignore
    // const origGetZoom = NeWMI.Engine.OpenLayers.Map.prototype.getZoom.bind(map.map);
    // // @ts-ignore
    // NeWMI.Engine.OpenLayers.Map.prototype.getZoom = () => { return Math.round(origGetZoom()) }

    this.waitForObjectPools();
  }

  periodicUpdate() {
    if (aspMngr) aspMngr.periodicUpdate();

    this.mainMapMngr.refresh();

    let subAreaMapMngrs = this.subAreaService.getSubAreas();
    for (let subArea of subAreaMapMngrs) {
      subArea.refresh();
    }

    this.statusBarSrv.refresh();
  }

  private waitForObjectPools() {
    if (aspMngr.allPoolsInitialized()) {
      this.msgMngr.openWebSocket(true /* quiet */);
      return;
    }
    setTimeout(this.waitForObjectPools, 100);
  }
  
  private setSplit(splitScreen: boolean) {
    this.splitScreenPreset = null;
    this.splitScreenPreset = splitScreen ? "middleSize" : "minSize";
    setTimeout(() => this.cdr.detectChanges(), 100);
  }
}
